import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-45ed2b20")

_pushScopeId("data-v-45ed2b20")
const _hoisted_1 = { class: "performanceOverview" }
const _hoisted_2 = { class: "dialog-footer" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_5 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createVNode("a", { style: {"text-decoration":"none"} }, "点击跳转", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 编辑版本 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 删除数据")
const _hoisted_10 = { class: "corePerformance6" }
const _hoisted_11 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("测试数据详情")
], -1)
const _hoisted_12 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 导出数据")
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "EventCount", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, "时长(ms)", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("测试数据趋势")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_footer = _resolveComponent("el-footer")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode(_component_el_tabs, {
                  onTabClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.tabsChange(_ctx.activeName))),
                  type: "card",
                  modelValue: _ctx.activeName,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.activeName = $event))
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterListAll, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_tab_pane, {
                        key: index,
                        name: index,
                        label: item.name
                      }, {
                        default: _withId(() => [
                          _withDirectives(_createVNode(_component_el_card, null, {
                            default: _withId(() => [
                              _createVNode(_component_el_dialog, {
                                modelValue: _ctx.dialogFormVisible1,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogFormVisible1 = $event)),
                                width: "30%"
                              }, {
                                footer: _withId(() => [
                                  _createVNode("span", _hoisted_2, [
                                    _createVNode(_component_el_button, {
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogFormVisible1 = false))
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_3
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      onClick: ($event: any) => (_ctx.dialogFormVisible2(index, item.form.id_test))
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_4
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]),
                                default: _withId(() => [
                                  _createVNode(_component_el_form, {
                                    class: "demo-form-inline",
                                    inline: true
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_form_item, {
                                        class: "reportName",
                                        label: "当前版本"
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_input, {
                                            size: "small",
                                            class: "report-input",
                                            modelValue: _ctx.logName,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.logName = $event)),
                                            autocomplete: "off",
                                            width: "500"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["modelValue"]),
                              _createVNode(_component_el_form, {
                                inline: true,
                                model: item.form,
                                size: "mini"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_form_item, {
                                    class: "iTemWidth3",
                                    label: "选择日期"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        filterable: "",
                                        modelValue: item.form.date,
                                        "onUpdate:modelValue": ($event: any) => (item.form.date = $event),
                                        onChange: ($event: any) => (
                        _ctx.date(index, [
                          'date',
                          'type',
                          'subtype',
                          'scene',
                          'UUID',
                          'id_test',
                          'old_test',
                          'datePick',
                          'process',
                          'thread',
                          'so',
                        ])
                      ),
                                        placeholder: "请选择"
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateOptions, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item,
                                              label: item.date,
                                              value: item.date
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_form_item, {
                                    class: "iTemWidth3",
                                    label: "测试类型"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        filterable: "",
                                        modelValue: item.form.type,
                                        "onUpdate:modelValue": ($event: any) => (item.form.type = $event),
                                        onChange: ($event: any) => (
                        _ctx.date(index, [
                          'type',
                          'subtype',
                          'scene',
                          'old_test',
                          'UUID',
                          'id_test',
                          'datePick',
                          'process',
                          'thread',
                          'so',
                        ])
                      ),
                                        placeholder: "请选择"
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.typeOptions, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.report_type,
                                              label: item.chinese,
                                              value: item.report_type
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_form_item, {
                                    class: "reportName",
                                    label: "测试子类型"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: item.form.subtype,
                                        "onUpdate:modelValue": ($event: any) => (item.form.subtype = $event),
                                        onChange: ($event: any) => (
                        _ctx.date(index, [
                          'subtype',
                          'scene',
                          'UUID',
                          'old_test',
                          'id_test',
                          'datePick',
                          'process',
                          'thread',
                          'so',
                        ])
                      ),
                                        placeholder: "请选择"
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subtypeOptions, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.subtype,
                                              label: item.chinese,
                                              value: item.subtype
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _withDirectives(_createVNode(_component_el_form_item, {
                                    class: "reportName",
                                    label: "皮肤"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: item.form.scene,
                                        "onUpdate:modelValue": ($event: any) => (item.form.scene = $event),
                                        onChange: ($event: any) => (
                        _ctx.date(index, [
                          'scene',
                          'UUID',
                          'id_test',
                          'old_test',
                          'datePick',
                          'process',
                          'thread',
                          'so',
                        ])
                      ),
                                        placeholder: "请选择"
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sceneOptions, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.scene_id,
                                              label: item.chinese,
                                              value: item.scene_id
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                    ]),
                                    _: 2
                                  }, 1536), [
                                    [_vShow, item.form.type == 4]
                                  ]),
                                  _createVNode(_component_el_form_item, {
                                    class: "reportName",
                                    label: "测试机型"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: item.form.uuid,
                                        "onUpdate:modelValue": ($event: any) => (item.form.uuid = $event),
                                        onChange: ($event: any) => (
                        _ctx.date(index, [
                          'UUID',
                          'id_test',
                          'datePick',
                          'old_test',
                          'process',
                          'thread',
                          'so',
                        ])
                      ),
                                        placeholder: "请选择"
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deviceOptions, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.UUID,
                                              label: item.name,
                                              value: item.UUID
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_form_item, { label: "当前版本" }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: item.form.id_test,
                                        "onUpdate:modelValue": ($event: any) => (item.form.id_test = $event),
                                        placeholder: "请选择",
                                        onChange: ($event: any) => (
                        _ctx.date(index, [
                          'id_test',
                          'datePick',
                          'process',
                          'thread',
                          'so',
                          'old_test',
                        ])
                      )
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.versionOptions, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.id_test,
                                              label: item.game_version,
                                              value: item.id_test
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_form_item, { label: "测试场景" }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        onChange: ($event: any) => (
                        _ctx.date(index, [
                          'datePick',
                          'process',
                          'thread',
                          'so',
                          'log',
                        ])
                      ),
                                        modelValue: item.form.label,
                                        "onUpdate:modelValue": ($event: any) => (item.form.label = $event),
                                        placeholder: "请选择"
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.labelOptions, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.Label,
                                              label: item.Label,
                                              value: item.Label
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["model"]),
                              _createVNode(_component_el_form, {
                                class: "spacForm",
                                size: "mini",
                                inline: true
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_form_item, {
                                    class: "iTemWidth3",
                                    label: "对比日期"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        filterable: "",
                                        modelValue: item.form.date1,
                                        "onUpdate:modelValue": ($event: any) => (item.form.date1 = $event),
                                        onChange: ($event: any) => (_ctx.onOldDateChange(index)),
                                        placeholder: "请选择"
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateOptions, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item,
                                              label: item.date,
                                              value: item.date
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_form_item, {
                                    class: "iTemWidth3",
                                    label: "对比类型"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        filterable: "",
                                        modelValue: item.form.old_type,
                                        "onUpdate:modelValue": ($event: any) => (item.form.old_type = $event),
                                        onChange: ($event: any) => (_ctx.onOldTypeChange(index)),
                                        placeholder: "请选择"
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.oldTypeOptions, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.report_type,
                                              label: item.chinese,
                                              value: item.report_type
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_form_item, {
                                    class: "reportName",
                                    label: "对比子类型"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: item.form.old_subtype,
                                        "onUpdate:modelValue": ($event: any) => (item.form.old_subtype = $event),
                                        onChange: ($event: any) => (_ctx.onOldSubTypeChange(index)),
                                        placeholder: "请选择"
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.oldSubTypeOptions, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.subtype,
                                              label: item.chinese,
                                              value: item.subtype
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _withDirectives(_createVNode(_component_el_form_item, {
                                    class: "reportName",
                                    label: "皮肤"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: item.form.old_scene,
                                        "onUpdate:modelValue": ($event: any) => (item.form.old_scene = $event),
                                        onChange: ($event: any) => (_ctx.onOldSceneChange(index)),
                                        placeholder: "请选择"
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.oldSceneOptions, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.scene_id,
                                              label: item.chinese,
                                              value: item.scene_id
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                    ]),
                                    _: 2
                                  }, 1536), [
                                    [_vShow, item.form.old_type == 4]
                                  ]),
                                  _createVNode(_component_el_form_item, {
                                    class: "reportName",
                                    label: "对比机型"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: item.form.old_uuid,
                                        "onUpdate:modelValue": ($event: any) => (item.form.old_uuid = $event),
                                        onChange: ($event: any) => (_ctx.onOldDeviceChange(index)),
                                        placeholder: "请选择"
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.oldDeviceOptions, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.UUID,
                                              label: item.name,
                                              value: item.UUID
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_form_item, { label: "对比版本" }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: item.form.old_test,
                                        "onUpdate:modelValue": ($event: any) => (item.form.old_test = $event),
                                        placeholder: "请选择",
                                        onChange: ($event: any) => (_ctx.onOldVersionChange(index))
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.versionOptionsOld, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.id_test,
                                              label: item.game_version,
                                              value: item.id_test
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode("div", _hoisted_5, [
                                _createVNode(_component_el_form, {
                                  class: "spacForm",
                                  size: "mini",
                                  inline: true
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_form_item, { label: "火焰图下载:" }, {
                                      default: _withId(() => [
                                        (_ctx.tableLog.pic == '' && _ctx.tableLog.pic_old === '')
                                          ? (_openBlock(), _createBlock("span", _hoisted_6, "暂无数据"))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    (_ctx.tableLog.pic != '')
                                      ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_button, {
                                              class: "editBtn",
                                              size: "mini"
                                            }, {
                                              default: _withId(() => [
                                                _createVNode("a", {
                                                  style: {"text-decoration":"none"},
                                                  download: "",
                                                  href: _ctx.tableLog.pic
                                                }, "当前版本", 8, ["href"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.tableLog.pic_old != '')
                                      ? (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_button, {
                                              class: "editBtn",
                                              size: "mini"
                                            }, {
                                              default: _withId(() => [
                                                _createVNode("a", {
                                                  style: {"text-decoration":"none"},
                                                  download: "",
                                                  href: _ctx.tableLog.pic_old
                                                }, "对比版本", 8, ["href"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_el_form_item, {
                                      onClick: _ctx.packageBtn,
                                      label: "安装包下载："
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_button, {
                                          class: "editBtn",
                                          size: "mini"
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_7
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]),
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_button, {
                                          size: "mini",
                                          type: "primary",
                                          onClick: ($event: any) => (_ctx.editBtn(item.form.id_test))
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_8
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode("div", null, [
                                  _createVNode(_component_el_button, {
                                    size: "mini",
                                    type: "primary",
                                    onClick: ($event: any) => (_ctx.deleteData(index))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_9
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ])
                              ]),
                              _createVNode("div", _hoisted_10, [
                                _hoisted_11,
                                _createVNode("div", _hoisted_12, [
                                  _createVNode(_component_el_form, {
                                    class: "spacForm",
                                    size: "mini",
                                    inline: true
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_form_item, { label: "搜索" }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_input, {
                                            modelValue: _ctx.serch_input,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.serch_input = $event)),
                                            onChange: ($event: any) => (_ctx.serchChange(index)),
                                            "prefix-icon": "el-icon-search",
                                            size: "mini"
                                          }, null, 8, ["modelValue", "onChange"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_el_form_item, { label: "Top" }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_select, {
                                            onChange: ($event: any) => (_ctx.date(index, [], true)),
                                            modelValue: item.form.size,
                                            "onUpdate:modelValue": ($event: any) => (item.form.size = $event),
                                            placeholder: "请选择"
                                          }, {
                                            default: _withId(() => [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sizeOptions, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item,
                                                  label: item,
                                                  value: item
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_el_form_item, null, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_switch, {
                                            modelValue: _ctx.is_null_arr[index],
                                            "onUpdate:modelValue": ($event: any) => (_ctx.is_null_arr[index] = $event),
                                            "active-text": "对比版本空数据",
                                            onChange: ($event: any) => (_ctx.onIsNullChange(index))
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode("div", null, [
                                    _createVNode(_component_el_button, {
                                      size: "mini",
                                      type: "primary",
                                      onClick: ($event: any) => (_ctx.exportExcel(index))
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_13
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]),
                                _withDirectives(_createVNode(_component_el_table, {
                                  border: "",
                                  onSortChange: _ctx.sort_change,
                                  class: "testDetailTable",
                                  data: _ctx.tableData,
                                  style: {"width":"100%"}
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_table_column, {
                                      label: "进程",
                                      prop: "ProcessName",
                                      width: "250",
                                      sortable: "custom"
                                    }, {
                                      default: _withId((scope) => [
                                        _createTextVNode(_toDisplayString(scope.row.ProcessName), 1)
                                      ]),
                                      _: 1
                                    }),
                                    (index != 0)
                                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                                          key: 0,
                                          label: "线程",
                                          prop: "ThreadName",
                                          width: "150",
                                          sortable: "custom"
                                        }, {
                                          default: _withId((scope) => [
                                            _createTextVNode(_toDisplayString(scope.row.ThreadName), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (index == 1)
                                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                                          key: 1,
                                          label: "so",
                                          prop: "LibraryName",
                                          width: "150",
                                          sortable: "custom"
                                        }, {
                                          default: _withId((scope) => [
                                            _createTextVNode(_toDisplayString(scope.row.LibraryName), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_el_table_column, {
                                      label: _ctx.getHead(index),
                                      prop: "name",
                                      width: _ctx.getWidht(index),
                                      sortable: "custom"
                                    }, {
                                      default: _withId((scope) => [
                                        _createTextVNode(_toDisplayString(scope.row.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "width"]),
                                    _createVNode(_component_el_table_column, {
                                      label: "百分比",
                                      align: "center"
                                    }, {
                                      header: _withId(() => [
                                        _createVNode("span", null, _toDisplayString(index == 1 ? "百分比(进程)" : "百分比"), 1)
                                      ]),
                                      default: _withId(() => [
                                        _createVNode(_component_el_table_column, {
                                          label: "当前版本",
                                          prop: "rate",
                                          width: "100",
                                          sortable: "custom"
                                        }, {
                                          default: _withId((scope) => [
                                            _createVNode("span", null, _toDisplayString(scope.row.rate.toFixed(2)), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_table_column, {
                                          label: "对比版本",
                                          prop: "old_rate",
                                          width: "100",
                                          sortable: "custom"
                                        }, {
                                          default: _withId((scope) => [
                                            _createVNode("span", null, _toDisplayString(scope.row.old_rate === ""
                              ? "--"
                              : scope.row.old_rate.toFixed(2)), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_table_column, {
                                          label: "趋势",
                                          prop: "change_rate",
                                          width: "100",
                                          sortable: "custom"
                                        }, {
                                          default: _withId((scope) => [
                                            _createVNode("span", {
                                              style: 
                              'color:' +
                              _ctx.com_num_color(
                                _ctx.com_num(
                                  scope.row.rate,
                                  scope.row.old_rate,
                                  'rate'
                                )
                              )
                            
                                            }, _toDisplayString(_ctx.com_num(
                                scope.row.rate,
                                scope.row.old_rate,
                                "rate"
                              )), 5)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_table_column, {
                                      width: "180",
                                      align: "center"
                                    }, {
                                      header: _withId(() => [
                                        _hoisted_14
                                      ]),
                                      default: _withId(() => [
                                        _createVNode(_component_el_table_column, {
                                          label: "当前版本",
                                          prop: "ms",
                                          width: "100",
                                          sortable: "custom"
                                        }, {
                                          default: _withId((scope) => [
                                            _createVNode("span", null, _toDisplayString(scope.row.ms), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_table_column, {
                                          label: "对比版本",
                                          prop: "old_ms",
                                          width: "100",
                                          sortable: "custom"
                                        }, {
                                          default: _withId((scope) => [
                                            _createVNode("span", null, _toDisplayString(scope.row.old_ms === "" ? "--" : scope.row.old_ms), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_table_column, {
                                          label: "趋势",
                                          prop: "change_ms",
                                          width: "100",
                                          sortable: "custom"
                                        }, {
                                          default: _withId((scope) => [
                                            _createVNode("span", {
                                              style: 
                              'color:' +
                              _ctx.com_num_color(
                                _ctx.com_num(scope.row.ms, scope.row.old_ms, 'ms')
                              )
                            
                                            }, _toDisplayString(_ctx.com_num(scope.row.ms, scope.row.old_ms, "ms")), 5)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      width: "180",
                                      align: "center"
                                    }, {
                                      header: _withId(() => [
                                        _hoisted_15
                                      ]),
                                      default: _withId(() => [
                                        _createVNode(_component_el_table_column, {
                                          label: "当前版本",
                                          prop: "ms",
                                          width: "100",
                                          sortable: "custom"
                                        }, {
                                          default: _withId((scope) => [
                                            _createVNode("span", null, _toDisplayString(scope.row.real_ms
                              ? scope.row.real_ms.toFixed(2)
                              : "--"), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_table_column, {
                                          label: "对比版本",
                                          prop: "old_ms",
                                          width: "100",
                                          sortable: "custom"
                                        }, {
                                          default: _withId((scope) => [
                                            _createVNode("span", null, _toDisplayString(scope.row.old_real_ms === ""
                              ? "--"
                              : scope.row.old_real_ms), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_table_column, {
                                          label: "趋势",
                                          prop: "change_real_ms",
                                          width: "100",
                                          sortable: "custom"
                                        }, {
                                          default: _withId((scope) => [
                                            _createVNode("span", {
                                              style: 
                              'color:' +
                              _ctx.com_num_color(
                                _ctx.com_num(
                                  scope.row.real_ms,
                                  scope.row.old_real_ms,
                                  'ms'
                                )
                              )
                            
                                            }, _toDisplayString(_ctx.com_num(
                                scope.row.real_ms,
                                scope.row.old_real_ms,
                                "ms"
                              )), 5)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onSortChange", "data"]), [
                                  [_directive_loading, _ctx.tableLoding]
                                ]),
                                _createVNode(_component_el_footer, { style: {"padding":"0px"} }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_form, {
                                      inline: true,
                                      size: "mini"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_pagination, {
                                              currentPage: item.form.currentPage,
                                              "onUpdate:currentPage": ($event: any) => (item.form.currentPage = $event),
                                              "page-size": item.form.size1,
                                              layout: "total, prev, pager, next, jumper",
                                              total: _ctx.tableDataAll.count,
                                              onCurrentChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSearch(_ctx.activeName)))
                                            }, null, 8, ["currentPage", "onUpdate:currentPage", "page-size", "total"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createVNode("div", null, [
                                _hoisted_16,
                                _createVNode(_component_el_form, {
                                  class: "spacForm",
                                  size: "mini",
                                  inline: true
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_form_item, { label: "时间" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_date_picker, {
                                          modelValue: item.form.valueTime,
                                          "onUpdate:modelValue": ($event: any) => (item.form.valueTime = $event),
                                          type: "daterange",
                                          "range-separator": "To",
                                          "start-placeholder": "开始日期",
                                          "end-placeholder": "结束日期",
                                          onChange: ($event: any) => (_ctx.date(index, ['dateTo', 'params1'], false))
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_form_item, { label: "搜索" }, {
                                      default: _withId(() => [
                                        (index == 0)
                                          ? (_openBlock(), _createBlock(_component_el_select, {
                                              key: 0,
                                              "popper-append-to-body": false,
                                              "filter-method": _ctx.filterHospital,
                                              filterable: "",
                                              modelValue: item.form.inParms,
                                              "onUpdate:modelValue": ($event: any) => (item.form.inParms = $event),
                                              onChange: ($event: any) => (_ctx.date(index, ['params1'], false)),
                                              class: "input_none",
                                              multiple: "",
                                              "collapse-tags": "",
                                              placement: "right",
                                              placeholder: "请输入查询",
                                              style: {"width":"240px"}
                                            }, {
                                              default: _withId(() => [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allNames, (item, index) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: index,
                                                    label: item[0],
                                                    value: item[0]
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["filter-method", "modelValue", "onUpdate:modelValue", "onChange"]))
                                          : (_openBlock(), _createBlock(_component_el_select, {
                                              key: 1,
                                              "filter-method": _ctx.filterHospital,
                                              filterable: "",
                                              modelValue: item.form.inParms,
                                              "onUpdate:modelValue": ($event: any) => (item.form.inParms = $event),
                                              onChange: ($event: any) => (_ctx.date(index, ['params1'], false)),
                                              class: "input_none",
                                              multiple: "",
                                              "collapse-tags": "",
                                              "collapse-tags-tooltip": "",
                                              placeholder: "请输入查询",
                                              style: {"width":"240px"}
                                            }, {
                                              default: _withId(() => [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allNames, (item, index) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: index,
                                                    label: item[0],
                                                    value: item[1]
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["filter-method", "modelValue", "onUpdate:modelValue", "onChange"]))
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_form_item, { label: "已选择指标" }, {
                                      default: _withId(() => [
                                        (index != 0)
                                          ? (_openBlock(), _createBlock(_component_el_select, {
                                              key: 0,
                                              modelValue: item.form.params,
                                              "onUpdate:modelValue": ($event: any) => (item.form.params = $event),
                                              class: "input_none",
                                              placeholder: "请展开列表查看",
                                              style: {"width":"240px"}
                                            }, {
                                              default: _withId(() => [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(Array.from(new Set(_ctx.newNames)), (item, index) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: index,
                                                    label: item[0],
                                                    value: item[1]
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                          : (_openBlock(), _createBlock(_component_el_select, {
                                              key: 1,
                                              modelValue: item.form.params,
                                              "onUpdate:modelValue": ($event: any) => (item.form.params = $event),
                                              class: "input_none",
                                              placement: "bottom",
                                              placeholder: "请展开列表查看",
                                              style: {"width":"240px"}
                                            }, {
                                              default: _withId(() => [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(Array.from(new Set(_ctx.newNames)), (item, index) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: index,
                                                    label: item[0],
                                                    value: item[0]
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_form_item, { label: "机型" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: item.form.uuid1,
                                          "onUpdate:modelValue": ($event: any) => (item.form.uuid1 = $event),
                                          onChange: ($event: any) => (_ctx.date(index, [], false)),
                                          placeholder: "请选择"
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deviceOptions, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.UUID,
                                                label: item.name,
                                                value: item.UUID
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode("div", null, [
                                  _withDirectives(_createVNode(_component_el_card, { style: {"margin-bottom":"20px"} }, {
                                    default: _withId(() => [
                                      (_ctx.show)
                                        ? (_openBlock(), _createBlock("div", {
                                            key: 0,
                                            id: 'percentage' + String(index),
                                            style: {"width":"100%","height":"350px"}
                                          }, null, 8, ["id"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1536), [
                                    [_directive_loading, _ctx.trendLoading]
                                  ]),
                                  _withDirectives(_createVNode(_component_el_card, { style: {"margin-bottom":"20px"} }, {
                                    default: _withId(() => [
                                      (_ctx.show)
                                        ? (_openBlock(), _createBlock("div", {
                                            key: 0,
                                            id: 'EventCount' + String(index),
                                            style: {"width":"100%","height":"350px"}
                                          }, null, 8, ["id"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1536), [
                                    [_directive_loading, _ctx.trendLoading]
                                  ]),
                                  _withDirectives(_createVNode(_component_el_card, null, {
                                    default: _withId(() => [
                                      (_ctx.show)
                                        ? (_openBlock(), _createBlock("div", {
                                            key: 0,
                                            id: 'ms' + String(index),
                                            style: {"width":"100%","height":"350px"}
                                          }, null, 8, ["id"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1536), [
                                    [_directive_loading, _ctx.trendLoading]
                                  ])
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1536), [
                            [_directive_loading, _ctx.loading]
                          ])
                        ]),
                        _: 2
                      }, 1032, ["name", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})